import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updateFinancialSchema = z.object({
  company: z.object({
    bill_integration_process: optionSchema,
    fee_rule: z.object({
      special_entries: z.array(
        z.object({
          id: z.string().optional().nullable(),
          target: optionSchema.optional().nullable(),
          fee_template: z.object({
            id: z.string().optional().nullable(),
            display_name: z.string().optional().nullable(),
            calculate_as: z.string().optional().nullable(),
          }).optional().nullable(),
          value: z.string().optional().nullable(),
          not_use_if_has_special_fee: z.boolean().optional().nullable(),
          execution_priority: z.number().optional().nullable(),
        }).optional().nullable(),
      ).optional().nullable(),
    }).optional().nullable(),
  }),
})

export type UpdateFinancialSchema = z.infer<typeof updateFinancialSchema>
